/**
 * Button Role enum
 *
 * @package lib-components
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

export enum BUTTON_ROLE {
	NONE = "none",
	SUBMIT = "submit"
}

export type BUTTON_ROLE_string = keyof typeof BUTTON_ROLE;

export const BUTTON_ROLE_default = "NONE";

export const BUTTON_ROLE_types = {
	none: "button",
	submit: "submit"
};
